import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11.5 21h-4.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v.5","key":"svg-0"}],["path",{"d":"M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0","key":"svg-1"}],["path",{"d":"M8 11v-4a4 4 0 1 1 8 0v4","key":"svg-2"}],["path",{"d":"M15 19l2 2l4 -4","key":"svg-3"}]]

const IconLockCheck = createReactComponent('outline', 'lock-check', 'LockCheck', __iconNode);

export default IconLockCheck;